import styled from 'styled-components';

import { get } from '../../../common/ui/get';

export const DividerVertical = styled.div`
    width: 1px;
    background-color: ${get('colors.border.subtle')};
`;
